module.exports = __webpack_public_path__ + "static/media/logo.45bd28f4.png";